import { compareStrings } from '../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { ContentControlWebAccessRule } from '@nirvana/shared/dtos/types/policies/common';
import { getLabelByExclusionItemPermission } from '../../../../../../utils/uiSettings/contentControl/content-control.values';

// sort by column type
export function sortByColumn(
  item1: ContentControlWebAccessRule,
  item2: ContentControlWebAccessRule,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.PERMISSION:
      return compareStrings(
        getLabelByExclusionItemPermission(item1.permission),
        getLabelByExclusionItemPermission(item2.permission),
        direction
      );

    case ColumnKeys.WEB_ADDRESS:
      return compareStrings(item1.webAddress, item2.webAddress, direction);
  }

  return 0;
}
